import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

//Components
import SideBar from "../../components/Sidebar/Sidebar";
import MobileCommissionIllustrate from "./MobileCommissionIllustrate";
import AgentComission from "./AgentComission";
import CommisionSimulator from "./CommisionSimulator";

//Miscellaneous
import Auxiliary from "../../hoc/Auxiliary/Auxiliary";
import { isDesktop } from "react-device-detect";

import * as actions from "../../store/ducks/commissionIllustrate/actions";

class CommissionIllustrate extends Component 
{
    constructor(props) 
    {
        super(props);
        this.state = 
        {
            changeTabs: "agent_commission",

            /*  agent commision */
            activePage: Number(process.env.REACT_APP_DATATABLE_PAGE),
            limit: Number(process.env.REACT_APP_DATATABLE_LIMIT),
            totalRecords: 0,
            loading: true,
            data: [],

            /*  commission simulator */
            company_total_bet: '',
            company_profit: '',
            total_bet: '',
            payout: '',
            comm_percentage: 0,
        };
    }

    componentDidMount() 
    {
        const listingArr = this.getFilterArray();
        this.props.funcGetList(listingArr);
    }

    shouldComponentUpdate(nextProps, nextState) 
	{
		const { t } = this.props;
		if (nextProps.rs !== this.props.rs && nextProps.rs !== undefined) 
        {
            if (nextProps.rs.responseCode === 200 && nextProps.rs.msgType === 'success') 
            {
                this.setState({
                    data: JSON.parse(nextProps.rs.data.result.row[0].data),
                    totalRecords: nextProps.rs.data.result.pagination.total_record,
                    loading: false,
                });
            }
        }

        return true;
	}

    getFilterArray = () => 
    {
        const listingArr = {};
        listingArr.page = this.state.activePage;
        listingArr.limit = this.state.limit;
        return listingArr;
    }

    toggleChangeTabs = (name) => 
    {
        this.setState({
            changeTabs: name,
        });
    }

    changeTabHandler = (e) => 
    {
        e.preventDefault();
        this.setState({
            pageShow: e.target.id,
        });
    }

    imageImport = (r) => 
    {
        let images = {};
        r.keys().map((item) => 
        {
            return (images[item.replace("./", "")] = r(item)["default"]);
        });
        return images;
    }

    render() 
    {
        
        const { t } = this.props;
        return (
            <Auxiliary>
                {isDesktop ? (
                    <section className="pf-dashboard comission">
                        <div className="x-container">
                            <SideBar />
                            <div className="row">
                                <div className="db-col col-12">
                                    <div className="pd-card-col">
                                        <h4>{t('sidebar.commission-illustrate')}</h4>
                                        <div className="pd-content">
                                            <div className='underline-nav-tabs'>
                                                <ul className='nav nav-tabs'>
                                                    <li className="nav-item">
                                                        <a className={`nav-link ${this.state.changeTabs === 'agent_commission' ? 'active' : ''}`} role="button" onClick={() => this.toggleChangeTabs("agent_commission")}>
                                                            <p>{t('commission-illustrate.agent-commission-details')}</p>
                                                        </a>
                                                    </li>
                                                    <li className="nav-item">
                                                        <a className={`nav-link ${this.state.changeTabs === 'commission_simulator' ? 'active' : ''}`} role="button" onClick={() => this.toggleChangeTabs("commission_simulator")}>
                                                            <p>{t('commission-illustrate.commission-simulator')}</p>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>

                                        {this.state.changeTabs === "agent_commission" && (
                                            <AgentComission 
                                                {...this.state}
                                                {...this.props}
                                            />
                                        )}
                                        {this.state.changeTabs === "commission_simulator" &&
                                            <CommisionSimulator 
                                                {...this.state}
                                                {...this.props}
                                            />
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                ) : (
                    <MobileCommissionIllustrate
                        {...this.state}
                        {...this.props}
                        changeTabHandler={this.changeTabHandler}
                        toggleModal={this.toggleModal}
                    />
                )}
            </Auxiliary>
        )
    }
}

const mapStateToProps = (state) => 
{
    const { commissionIllustrate } = state;
    return {
        rs: commissionIllustrate.rs,
        currentUser: state.currentUser,
    };
};

const mapDispatchToProps = (dispatch) => 
{
    return {
        funcGetList: (filter) => dispatch(actions.getList(filter)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withNamespaces("translation")(CommissionIllustrate));